import { render, staticRenderFns } from "./orderAll.vue?vue&type=template&id=3771f304&scoped=true&"
import script from "./orderAll.vue?vue&type=script&lang=js&"
export * from "./orderAll.vue?vue&type=script&lang=js&"
import style0 from "./orderAll.vue?vue&type=style&index=0&id=3771f304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3771f304",
  null
  
)

export default component.exports